let localizationApi: any;

export const getLocalizationApi = async ({ isSSR }: { isSSR?: any } = {}) => {
  if (localizationApi || isSSR) {
    return localizationApi;
  }

  localizationApi = (
    await import(/* webpackChunkName: "localization-api" */ './localization-api-chunk')
  ).default;

  return localizationApi;
};
